'use client';

import Link from 'next/link';
import { useTranslations } from 'next-intl';
import { usePathname } from 'next/navigation';

import type { ComponentProps, JSX } from 'react';

import { cn } from '~/utils';

export function Nav(): JSX.Element {
  const t = useTranslations();

  return (
    <div className='flex flex-1 gap-6 items-center justify-center'>
      <NavLink href='/'>{t('commons.browseAdSpaces')}</NavLink>
      <NavLink href='/profile/partner' exact={false}>
        {t('commons.monetizeYourSpace')}
      </NavLink>
      <NavLink href='/profile/expert' exact={false}>
        {t('commons.offerYourServices')}
      </NavLink>
    </div>
  );
}

interface INavLinkProps extends ComponentProps<typeof Link> {
  exact?: boolean;
}

function NavLink({
  href,
  className,
  exact = true,
  ...props
}: INavLinkProps): JSX.Element {
  const pathname = usePathname();
  const active = exact ? pathname === href : pathname.includes(href.toString());

  return (
    <Link
      href={href}
      className={cn(
        'relative font-medium leading-[130%]',
        className,
        active &&
          'after:content-[""] after:absolute after:left-0 after:right-0 after:h-1 after:bg-illicitGreen-500 after:bottom-[-26px] font-bold',
      )}
      {...props}
    />
  );
}
